import { Avatar, Col, Popover, Row, theme, Typography } from "antd";
import { useCallback } from "react";
import "./navbar.scss";
import { useLocation } from "react-router-dom";
import { getDisplayName } from "../../utils/user";
import { useUser, useDescope } from "@descope/react-sdk";

const NavBar = ({ handleClick, brandText }) => {
	const { useToken } = theme;
	const { token } = useToken();
	const location = useLocation();
	const { user, isUserLoading } = useUser();
	const fullName = getDisplayName(user).split(" ");
	const { logout } = useDescope();

	const logoutUser = useCallback(async () => {
		logout();
	}, [logout]);

	const getInitials = (fullName) => {
		if (fullName.length > 1) {
			const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
			return initials.toUpperCase();
		} else {
			return "Profile";
		}
	};
	if (isUserLoading) {
		return <></>;
	}

	const content = (
		<div>
			{/* <Typography.Title level={5}>Hello, {getDisplayName(user)}</Typography.Title>
			<Divider /> */}
			<p style={{ color: "red", cursor: "pointer" }} onClick={logoutUser}>
				Log out
			</p>
		</div>
	);

	return (
		<section>
			<div className="header-section">
				<Row className="header-row">
					<Col span={8} className="header-col">
						<div>
							<Typography className="menu-text">
								{location.state == null ? "New Companies" : location.state}
							</Typography>
						</div>
					</Col>
					<Col span={1}>
						<div className="search-section" style={{ background: token.colorBgContainer }}>
							<div className="avtar">
								<Popover content={content} trigger="click">
									<Avatar
										style={{
											backgroundColor: "#11047a",
											verticalAlign: "right",
											cursor: "pointer",
										}}
										size="large"
									>
										{getInitials(fullName)}
									</Avatar>
								</Popover>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</section>
	);
};

export default NavBar;
